import { render, staticRenderFns } from "./default-sort-column.vue?vue&type=template&id=3ec94eb4&"
import script from "./default-sort-column.vue?vue&type=script&lang=js&"
export * from "./default-sort-column.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports